import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { BaseDict } from "./dict";
import { config } from "./config";
import { PulseBetMarkets } from "./PulseBetMarkets";
import { PulseBetMarketsData } from "./data";
let _;
let _localMock;
let _msgBusMock;
let PageMethodsOverridenMockedMethods;
let PageMethodsMock;
let MasterEventsPageMethodsMock;
let BettingHistoryPageMethodsMock;
let BettingPageMethodsMock;
let UserInfoMock;
let OddsMock;
let NavHandlerMock;
let BetSlipUtil;
let SBMsgBusMock;
if (process.env.NODE_ENV === "development") {
    _ = require("sb-legacy-integration/lib-esm/mocks");
    _localMock = require("../../mocks");
    _msgBusMock = require("sb-msg-bus/lib/mock");
    PageMethodsMock = _.PageMethodsMock;
    PageMethodsOverridenMockedMethods = _localMock.PageMethodsOverridenMockedMethods;
    UserInfoMock = _.UserInfoMock;
    MasterEventsPageMethodsMock = _localMock.MasterEventsPageMethodsMock;
    BettingHistoryPageMethodsMock = _localMock.BettingHistoryPageMethodsMock;
    BettingPageMethodsMock = _localMock.BettingPageMethodsMock;
    OddsMock = _.OddsMock;
    NavHandlerMock = _.NavHandlerMock;
    BetSlipUtil = _.BetSlipUtilMock;
    SBMsgBusMock = _msgBusMock.SBMsgBusMock;
}
export class PulseBetMarketsRoot extends BaseBlock {
    // constructor sets defaults
    constructor(domId, options = {
        dict: BaseDict,
        cms: {},
        navHandler: {},
        dataProvider: {},
        betSlipUtil: {},
        oddsUtil: {},
        facade: {}
    }) {
        super(domId, options);
        if (process.env.NODE_ENV === "development") {
            // setup data mocks for debug build
            this.dataProvider = new PulseBetMarketsData({
                pageMethods: new PageMethodsMock(new PageMethodsOverridenMockedMethods()),
                masterEventsPageMethoods: new MasterEventsPageMethodsMock(),
                bettingHistoryPageMethods: new BettingHistoryPageMethodsMock(),
                bettingPageMethods: new BettingPageMethodsMock(),
                userInfo: UserInfoMock,
                sbMsgBus: new SBMsgBusMock()
            }, BaseDict, config, new OddsMock(), new BetSlipUtil(), new NavHandlerMock());
            // setup dictionary for debug build
            this.options.dict = BaseDict;
            //export data store to window for debug purposes
            window["PulseBetMarketsDATA"] = this.dataProvider;
        }
        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = Object.assign(Object.assign({}, BaseDict), (options.dict || {}));
        // merge default and CMS options
        this.options.cms = Object.assign(Object.assign({}, config), (options.cms || {}));
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            // use pagemethods passed during the construction from the
            // mobile application
            this.dataProvider = new PulseBetMarketsData(options.dataProvider, this.options.dict, this.options.cms, options.oddsUtil, options.betSlipUtil, options.navHandler);
        }
    }
    activate() {
        return super.activate(React.createElement(PulseBetMarkets, { dataProvider: this.dataProvider, dict: this.options.dict }));
    }
}
window["PulseBetMarkets"] = PulseBetMarketsRoot;
broadcastBlockLoad("PulseBetMarkets");
//# sourceMappingURL=index.js.map